import { render } from "./BaseBadge.vue?vue&type=template&id=aae4324a&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=aae4324a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aae4324a"

export default script